import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { FormatMoney } from '../../utils/formatMoney'
import { useLocation, useParams } from 'react-router-dom';
import { formatDate } from '../../utils/convertDate';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import TreasuryBillClass from '../../services/treasuryBill';
import BackButton from '../../components/BackButton';

const ViewTreasuryBookings = () => {
  const location = useLocation();
  const { bookingId } = useParams();

  // State variables for all fields in the UI
  const [security, setSecurity] = useState('');
  const [faceValue, setFaceValue] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [discountRate, setDiscountRate] = useState('');
  const [tenor, setTenor] = useState('');
  const [settlementDate, setSettlementDate] = useState(null);
  const [maturityDate, setMaturityDate] = useState(null);
  const [redemptionValue, setRedemptionValue] = useState('');
  const [yieldValue, setYieldValue] = useState('');

  useEffect(() => {
    if (bookingId) {
        const GetBooking = async() => {
          const singleBooking = await TreasuryBillClass.getBookingById(parseInt(bookingId))
          if(singleBooking && singleBooking.status){
            const data = singleBooking.data;
            
            // Set values from backend data
            setSecurity(data.security || '');
            setFaceValue(data.faceValue || '');
            setCustomerName(data.customerName || '');
            setAccountNumber(data.accountNumber || '');
            setEmailAddress(data.emailAddress || '');
            setTenor(data.tenor || '');
            setDiscountRate(data.discountRate || '');
            setRedemptionValue(data.redemptionValue || '');
            setYieldValue(data.yield || '');
            
            // Handle dates
            if (data.settlementDate && data.settlementDate !== "0001-01-01T00:00:00") {
              setSettlementDate(new Date(data.settlementDate));
            }
            if (data.maturityDate && data.maturityDate !== "0001-01-01T00:00:00") {
              setMaturityDate(new Date(data.maturityDate));
            }
          }
        }
        GetBooking()
    }
  }, [bookingId]);

  return (
    <Layout title={"View Booking Details"} pageTag={"treasury_bill"} current={'/bookings/:bookingId'}>
      <React.Fragment>
        <div className="min-h-full">
          <div className="flex flex-1 flex-col">
                <BackButton />
            <main className="flex-1">
              <div className="py-6">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="px-4 py-5 sm:p-6">
                      <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-3">
                        {/* Security */}
                        <div>
                          <label htmlFor="security" className="block text-sm font-medium text-gray-700">Security</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="security"
                              id="security"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={security}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        {/* Face Value */}
                        <div>
                          <label htmlFor="faceValue" className="block text-sm font-medium text-gray-700">Face Value</label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">₦</span>
                            </div>
                            <input
                              type="text"
                              name="faceValue"
                              id="faceValue"
                              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                              value={FormatMoney(faceValue, 'NGN')}
                              readOnly={true}
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">NGN</span>
                            </div>
                          </div>
                        </div>

                        {/* Customer's Name */}
                        <div>
                          <label htmlFor="customerName" className="block text-sm font-medium text-gray-700">Customer's Name</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="customerName"
                              id="customerName"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={customerName}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        {/* Account Number */}
                        <div>
                          <label htmlFor="accountNumber" className="block text-sm font-medium text-gray-700">Account Number</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="accountNumber"
                              id="accountNumber"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={accountNumber}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        {/* Email Address */}
                        <div>
                          <label htmlFor="emailAddress" className="block text-sm font-medium text-gray-700">Email Address</label>
                          <div className="mt-1">
                            <input
                              type="email"
                              name="emailAddress"
                              id="emailAddress"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={emailAddress}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        {/* Discount rate */}
                        <div>
                          <label htmlFor="discountRate" className="block text-sm font-medium text-gray-700">Discount rate</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="discountRate"
                              id="discountRate"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={`${discountRate}${discountRate ? '%' : ''}`}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        {/* Tenor */}
                        <div>
                          <label htmlFor="tenor" className="block text-sm font-medium text-gray-700">Tenor</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="tenor"
                              id="tenor"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={`${tenor}${tenor ? ' days' : ''}`}
                              readOnly={true}
                            />
                          </div>
                        </div>

                        {/* Settlement Date */}
                        <div>
                          <label htmlFor="settlementDate" className="block text-sm font-medium text-gray-700">Settlement Date</label>
                          <div className="mt-1">
                            <DatePicker
                              value={settlementDate}
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              disabled={true}
                              calendarClassName="placeholder-gray-400"
                            />
                          </div>
                        </div>

                        {/* Maturity Date */}
                        <div>
                          <label htmlFor="maturityDate" className="block text-sm font-medium text-gray-700">Maturity Date</label>
                          <div className="mt-1">
                            <DatePicker
                              value={maturityDate}
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              disabled={true}
                              calendarClassName="placeholder-gray-400"
                            />
                          </div>
                        </div>

                        {/* Redemption Value */}
                        <div>
                          <label htmlFor="redemptionValue" className="block text-sm font-medium text-gray-700">Redemption Value</label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">₦</span>
                            </div>
                            <input
                              type="text"
                              name="redemptionValue"
                              id="redemptionValue"
                              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                              value={FormatMoney(redemptionValue, 'NGN')}
                              readOnly={true}
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">NGN</span>
                            </div>
                          </div>
                        </div>

                        {/* Yield */}
                        <div>
                          <label htmlFor="yieldValue" className="block text-sm font-medium text-gray-700">Yield</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="yieldValue"
                              id="yieldValue"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                               value={`${yieldValue}${yieldValue ? '%' : ''}`}
                              readOnly={true}
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </React.Fragment>
    </Layout>
  )
}

export default ViewTreasuryBookings